import { combineReducers } from 'redux';
import vehicles from '../vehicles/store/reducer';

export default combineReducers({
  vehicles,
});
